import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from './icons/Icons';
export const Hook = () => {
  return <section className="pt-20 md:pt-28 pb-10 md:pb-14 bg-brand-pink relative" data-id="element-240">
      {/* Layered wave separator — two-tone for depth */}
      <div className="absolute top-0 left-0 right-0 leading-[0] pointer-events-none -translate-y-px" data-id="element-241">
        <svg viewBox="0 0 1440 110" preserveAspectRatio="none" className="w-full h-[70px] md:h-[110px] block absolute top-0 left-0" aria-hidden="true" data-id="element-242">
          <path d="M0,50 C240,100 480,10 720,40 C960,70 1200,95 1440,50 L1440,0 L0,0 Z" fill="#FBF7F0" data-id="element-243" />
        </svg>
        <svg viewBox="0 0 1440 90" preserveAspectRatio="none" className="w-full h-[60px] md:h-[90px] block relative" aria-hidden="true" data-id="element-244">
          <path d="M0,40 C240,90 480,0 720,30 C960,60 1200,80 1440,40 L1440,0 L0,0 Z" fill="#FBF7F0" fillOpacity="0.55" data-id="element-245" />
        </svg>
      </div>

      {/* Ornamental gold flourish — intensified */}
      <div className="absolute left-1/2 -translate-x-1/2 top-14 md:top-20 flex flex-col items-center gap-2 pointer-events-none" aria-hidden="true" data-id="element-246">
        <div className="flex items-center gap-3 md:gap-5" data-id="element-247">
          <span className="h-px w-14 md:w-24 bg-gradient-to-r from-transparent via-brand-gold/40 to-brand-gold" data-id="element-248"></span>
          <span className="text-brand-gold text-lg md:text-2xl tracking-widest drop-shadow-sm" data-id="element-249">
            ✦
          </span>
          <span className="h-px w-14 md:w-24 bg-gradient-to-l from-transparent via-brand-gold/40 to-brand-gold" data-id="element-250"></span>
        </div>
        <span className="h-px w-8 md:w-12 bg-brand-gold/40" data-id="element-251"></span>
      </div>

      <div className="container mx-auto px-6 max-w-3xl text-center relative z-10" data-id="element-252">
        {/* El Gancho */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="mb-8 md:mb-10" data-id="element-253">
          <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-4" data-id="element-254">
            Lo que tu piel necesita.
          </h2>
          <p className="text-lg md:text-xl text-brand-charcoal/80 leading-relaxed mb-3" data-id="element-255">
            Hay algo que ningún filtro de Instagram puede darte.
          </p>
          <p className="text-lg md:text-xl text-brand-charcoal/80 leading-relaxed mb-4" data-id="element-256">
            No lo da el mejor corrector del mercado. No lo da la crema de $80
            que compraste convencida de que esta vez sí funcionaría.
          </p>

          <div className="relative py-6 my-4" data-id="element-257">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 text-brand-gold/20" data-id="element-258">
              <QuoteIcon size={56} data-id="element-259" />
            </div>
            <p className="relative z-10 text-2xl md:text-4xl font-serif italic text-brand-charcoal leading-snug" data-id="element-260">
              Es esa sensación de mirarte al espejo —sin prepararte, sin editar,
              sin cubrir nada— y simplemente decir:
              <br data-id="element-261" />
              <br data-id="element-262" />
              <span className="text-brand-bronze font-medium" data-id="element-263">
                "Qué bien se ve mi piel."
              </span>
            </p>
          </div>

          <p className="text-lg md:text-xl text-brand-charcoal/80 leading-relaxed mb-1" data-id="element-264">
            Si hace tiempo no sientes eso... no es tu culpa.
          </p>
          <p className="text-lg md:text-xl text-brand-charcoal/80 leading-relaxed font-medium" data-id="element-265">
            Es que nadie ha cuidado tu piel de la manera que realmente merece.
          </p>
          <p className="text-2xl font-serif text-brand-gold mt-3 italic" data-id="element-266">
            Hasta hoy.
          </p>
        </motion.div>

        {/* Divider */}
        <div className="flex justify-center mb-8 md:mb-10" data-id="element-267">
          <div className="h-px w-24 bg-brand-gold/30" data-id="element-268"></div>
        </div>

        {/* El Dolor Real */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-left md:text-center" data-id="element-269">
          <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-4" data-id="element-270">
            Seamos honestas.
          </h2>

          <div className="space-y-3 text-lg text-brand-charcoal/80 leading-relaxed mb-6" data-id="element-271">
            <p data-id="element-272">
              Llevas meses —quizás años— lidiando con algo que te incomoda más
              de lo que admites en voz alta.
            </p>
            <p data-id="element-273">
              Puede ser el acné que aparece justo cuando menos lo necesitas. Las
              manchas que no importa cuánto cubras, siguen ahí. La piel opaca
              que hace que te veas cansada aunque hayas dormido bien.
            </p>
            <p data-id="element-274">
              El vello que te limita, las verrugas que te incomodan, los labios
              que perdieron su color natural.
            </p>
            <p data-id="element-275">
              O simplemente esa sensación de que tu piel podría verse mejor — y
              no sabes por dónde empezar.
            </p>
            <p className="italic text-brand-charcoal" data-id="element-276">
              Y mientras tanto, el tiempo pasa. Cada mañana frente al espejo es
              una pequeña batalla que ya no quieres pelear.
            </p>
          </div>

          <div className="bg-brand-cream border border-brand-gold/30 p-6 md:p-10 rounded-2xl shadow-sm relative overflow-hidden" data-id="element-277">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-gold/20 via-brand-gold to-brand-gold/20" data-id="element-278"></div>
            <p className="text-xl font-medium text-brand-charcoal mb-3" data-id="element-279">
              Lo entendemos. Y tenemos algo importante que decirte:
            </p>
            <p className="text-2xl md:text-3xl font-serif text-brand-bronze leading-snug" data-id="element-280">
              Eso que ves en el espejo no es permanente. Es tratable. Y los
              resultados pueden ser extraordinarios.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};